import clone from "clone";
import { Language } from "../../shared/entities/language";

export class EmployeePersonalInformation
{
	/**
	 * Creates a new instance of the type.
	 * @param data The response data from which the instance should be created.
	 */
	public constructor(data: any)
	{
		this.firstName = data.firstName;
		this.lastName = data.lastName;
		this.socialSecurityNumber = data.cpr;
		this.email = data.email;
		this.phoneCountryCode = data.phoneCountryCode;
		this.phoneNumber = data.phoneNumber;
		this.communicationLanguage = Language.languageFromJSON(data.communicationLanguage);
		this.possibleCommunicationLanguages = data.languages
	}

	public firstName: string;
	public lastName: string;
	public socialSecurityNumber: string;
	public email: string;
	public phoneCountryCode: string;
	public phoneNumber: string;
	public communicationLanguage: Language;
	public readonly possibleCommunicationLanguages: Language[];

	/**
	 * Gets a clone of this instance, suitable for editing.
	 */
	public clone(): any
	{
		return clone(this);
	}

	/**
	 * Gets the data representing this instance.
	 */
	public toJSON(): any
	{
		return {
			firstName: this.firstName,
			lastName: this.lastName,
			cpr: this.socialSecurityNumber,
			email: this.email,
			phoneCountryCode: this.phoneCountryCode,
			phoneNumber: this.phoneNumber,
			communicationLanguage: this.communicationLanguage.value
		};
	}
}
